import { useQuery } from "@apollo/client";
import {
  PAPS_OPS_ADDRESS_BJ,
  PAPS_OPS_ADDRESS_CI,
  PAPS_OPS_ADDRESS_GN,
  PAPS_OPS_ADDRESS_ML,
  PAPS_OPS_ADDRESS_SN,
  PAPS_OPS_ADDRESS_TG,
} from "config/constants";
import { UserInfoFragment } from "domains/Users/graphql/fragments";
import gql from "graphql-tag";
import { GET_DELIVERY_SLOTS } from "graphql/Job/queries";
import { CountryCode } from "libphonenumber-js";

export const CURRENT_USER = gql`
  query currentUserCompany {
    currentUserCompany {
      code
      message
      error
      data {
        user {
          ...UserInfo
        }
      }
    }
  }
  ${UserInfoFragment}
`;

const CURRENT_CLIENT = gql`
  query currentClient {
    currentClient {
      data {
        client {
          client_UID
          _id
          client_email
          client_contact_email
          client_company_name
          client_ninea_url
          client_activity
          client_contact_job
          client_phone_number
          client_contact_firstname
          client_contact_lastname
          ranking
          client_address {
            address
            place_id
          }
          countries {
            code
            name
          }
          services
        }
      }
    }
  }
`;

export const CurrentUserSubscription = gql`
  subscription clientDeactivation($clientId: ID!) {
    clientDeactivation(clientId: $clientId)
  }
`;

export const useCurrentUser = () => {
  const { data, loading, error, refetch } = useQuery(CURRENT_USER);
  const company = data?.currentUserCompany;
  return { code: company?.code, user: company?.data?.user, loading, error, refetch };
};

export const useCurrentClient = () => {
  // TODO: Set the fetch policy to cache-fisrt to avoid unnecessary fetchs
  const { data, loading, error, refetch } = useQuery(CURRENT_CLIENT);
  return { client: data?.currentClient?.data?.client, loading, error, refetch };
};

export const useCountryCode = (): CountryCode => {
  const { client } = useCurrentClient();
  const { countries } = client || {};
  const countryCode = countries?.length ? countries?.map((element: any) => element?.code)[0]?.toUpperCase() : "SN";
  return countryCode;
};

export const useHupAdress = (countryCode?: CountryCode): string => {
  const code = countryCode ?? useCountryCode();
  switch (code) {
    case "CI":
      return PAPS_OPS_ADDRESS_CI;
    case "BJ":
      return PAPS_OPS_ADDRESS_BJ;
    case "GN":
      return PAPS_OPS_ADDRESS_GN;
    case "SN":
      return PAPS_OPS_ADDRESS_SN;
    case "ML":
      return PAPS_OPS_ADDRESS_ML;
    case "TG":
      return PAPS_OPS_ADDRESS_TG;
    default:
      return PAPS_OPS_ADDRESS_SN;
  }
};

export const useDeliverySlots = () => {
  // TODO: Set the fetch policy to cache-fisrt to avoid unnecessary fetchs
  const { data, refetch } = useQuery(GET_DELIVERY_SLOTS);
  const deliverySlots = data?.getDeliverySlots?.data?.[0];
  const morningSlotStart = deliverySlots?.Matin?.Pickup?.Client?.slotStart;
  const morningSlotEnd = deliverySlots?.Matin?.Pickup?.Client?.slotEnd;
  const afternoonSlotStart = deliverySlots?.Soir?.Pickup?.Client?.slotStart;
  const afternoonSlotEnd = deliverySlots?.Soir?.Pickup?.Client?.slotEnd;
  const allDaySlotStart = deliverySlots?.AllDay?.slotStart;
  const allDaySlotEnd = deliverySlots?.AllDay?.slotEnd;
  return {
    morningSlotStart,
    morningSlotEnd,
    afternoonSlotStart,
    afternoonSlotEnd,
    allDaySlotStart,
    allDaySlotEnd,
    refetch,
  };
};
